<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                blendForm: () => import('../forms/BlendForm'),
                honeyTypeForm: () => import('../forms/HoneyTypeForm'),
                fields: [
                    { type: 'autocomplete', text: 'Blend', value: 'blendId', rules: [v => !!v || 'Blend is required'], isRequired: true, form: () => import('./BlendForm'), apiMethod: 'Blends', claim: 'Blends' },
                    { type: 'autocomplete', text: 'Honey Type', value: 'honeyTypeId', rules: [v => !!v || 'Honey Type is required'], isRequired: true, form: () => import('./HoneyTypeForm'), apiMethod: 'HoneyTypes', claim: 'HoneyTypes' },
                ],
                apiMethod: 'BlendHoneyTypes',
                formTitle: 'Blend Honey Type',
            }
        },
    };
</script>
